module.exports = __webpack_public_path__ + "img/MatPL-5.d1832614.png";